import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getProjectByUrl } from './projectsData';
import { getProduct } from './shopData';

/* What the browser tab says.
 *
 * LUKEABC on its own everywhere, and LUKEABC, <name> on a project or a
 * product. A comma rather than a dash, because the site has no dashes in it
 * anywhere else.
 */

export const SITE_NAME = 'LUKEABC';

const SECTIONS = {
  '/': '',
  '/info': 'Info',
  '/links': 'Links',
  '/notes': 'Notes',
  '/versions': 'Versions',
  '/mail': 'Mail',
  '/contact': 'Contact',
  '/shop': 'Shop',
};

export default function PageTitle() {
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const path = location.pathname;
    let name = SECTIONS[path];

    if (name === undefined) {
      if (path.startsWith('/work/')) {
        const p = getProjectByUrl(path.slice('/work/'.length));
        name = p ? p.title : '';
      } else if (path.startsWith('/shop/')) {
        const p = getProduct(path.slice('/shop/'.length));
        name = p ? p.title : 'Shop';
      } else {
        name = '';
      }
    }

    document.title = name ? SITE_NAME + ', ' + name : SITE_NAME;
  }, [location.pathname, params]);

  return null;
}
